module.exports = __webpack_public_path__ + "img/copy-07.17c5d0a1.svg";